// eslint-disable-next-line
import React, { useEffect, useState } from "react";
import icon_Gif from "../assest/icon_gif.jpg";
import convertImageToBase64 from "../helpers/convertImageToBase64";
import { BsEyeSlash, BsPerson } from "react-icons/bs";
import { CiLock } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { FaEye } from "react-icons/fa";
import summaryApi from "../common/Api";
import { toast } from "react-toastify";
import axios from "axios";
// eslint-disable-next-line
import "react-toastify/dist/ReactToastify.css";
import "../App.css"; // Import your custom CSS

const SignUp = () => {
  const [ setBase64Image] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const [data, setData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBase64Image = async () => {
      try {
        const response = await fetch(icon_Gif);
        const blob = await response.blob();
        const base64String = await convertImageToBase64(blob);
        setBase64Image(base64String);
      } catch (error) {
        console.error("Error converting image to Base64:", error);
      }
    };

    fetchBase64Image();
  }, []);

  const handleChange = (e) => {
    setIsClicked(false);
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsClicked(true);

    if (data.username.length < 3 || data.username.length > 20) {
      toast.error("Username must be between 3 and 20 characters long", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      return;
    }
    
    // eslint-disable-next-line no-useless-escape
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!emailRegex.test(data.email)) {
      toast.error("Please enter a valid email address", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      return;
    }

    if (data.password.length < 8) {
      toast.error("Password must be at least 8 characters long", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      return;
    }

    if (data.password !== data.confirmPassword) {
      toast.error("Password and Confirm Password must be the same", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      return;
    }

    try {
      await axios.post(summaryApi.signUp.url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      toast.success("User registered successfully!", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      navigate("/sign-in");
    } catch (error) {
      // console.error("Error:", error);
      toast.error(
        error.response?.data?.message ||
          "Registration failed. Please try again.",
        {
          position: "bottom-center",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
        }
      );
    }
  };

  return (
    <div className="bg-white w-[320px] md:w-[450px] container mx-auto flex items-center justify-center flex-col max-w-md my-5 rounded-2xl">
      <h1 className="font-bold text-2xl p-5">Register</h1>

      <form className="flex flex-col p-5 w-full" onSubmit={handleSubmit}>
        <label className="text-sm" htmlFor="username">
          Username
        </label>
        <div className="flex items-center">
          <BsPerson className="text-gray-600" />
          <input
            className="w-full p-3 outline-none"
            type="text"
            name="username"
            id="username"
            placeholder="Enter Your Name"
            required
            value={data.username}
            onChange={handleChange}
          />
        </div>

        <hr className="bg-main-background h-0.5 mb-4 mt-1" />

        <label className="text-sm" htmlFor="email">
          Email
        </label>
        <div className="flex items-center">
          <MdOutlineMarkEmailRead className="text-gray-500" />
          <input
            className="w-full p-3 outline-none"
            type="email"
            name="email"
            id="email"
            placeholder="Enter Your Email"
            required
            value={data.email}
            onChange={handleChange}
          />
        </div>

        <hr className="bg-main-background h-0.5 mb-4 mt-1" />

        <label className="text-sm" htmlFor="password">
          Password
        </label>
        <div className="flex items-center">
          <CiLock className="text-gray-500" />
          <input
            className="w-full p-3 outline-none"
            type={showPassword ? "text" : "password"}
            name="password"
            id="password"
            placeholder="Enter Your Password"
            required
            value={data.password}
            onChange={handleChange}
          />
          <span
            className="cursor-pointer text-gray-600"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <BsEyeSlash /> : <FaEye />}
          </span>
        </div>

        <hr className="bg-main-background h-0.5 mb-4 mt-1" />

        <label className="text-sm" htmlFor="confirmPassword">
          Confirm Password
        </label>
        <div className="flex items-center">
          <CiLock className="text-gray-600" />
          <input
            className="w-full p-3 outline-none"
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            id="confirmPassword"
            placeholder="Confirm Password"
            required
            value={data.confirmPassword}
            onChange={handleChange}
          />
          <span
            className="cursor-pointer text-gray-600"
            onClick={() => setShowConfirmPassword((prev) => !prev)}
          >
            {showConfirmPassword ? <BsEyeSlash /> : <FaEye />}
          </span>
        </div>

        <hr className="bg-main-background h-0.5 mb-4 mt-1" />

        <button
          type="submit"
          disabled={isClicked}
          className="flex items-center justify-center bg-main-background text-white p-3 w-full mb-2 mt-4 rounded-full"
        >
          REGISTER
        </button>

        <div className="text-gray-600 my-4 text-center">
          <p className="mb-2">Already Have Account?</p>
          <Link to="/sign-in" className="text-main-background hover:underline">
            Log In
          </Link>
        </div>
      </form>
    </div>
  );
};

export default SignUp;
